import * as Types from '../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type GetProjectFoldersQueryVariables = Types.Exact<{
  input: Types.ProjectFoldersQueryInput;
}>;


export type GetProjectFoldersQuery = { __typename?: 'QueryModel', projectFolders: { __typename?: 'ProjectFoldersQueryModel', folders: Array<{ __typename?: 'StructuralFolder', path: string, clientFolders: Array<{ __typename?: 'CustomerFolder', id: number, path: string, fullPath: string, syncStatus: Types.SyncStatus, syncErrorMessage?: string | null, customerNumber?: string | null, projectFolders: Array<{ __typename?: 'ProjectFolder', id: number, name: string, syncStatus: Types.SyncStatus, syncErrorMessage?: string | null, fullPath: string, currentFolderPath: string, targetFolderPath?: string | null, projectId: number }>, groupedFolders: Array<{ __typename?: 'GroupedFolder', id: number, name: string, syncStatus: Types.SyncStatus, syncErrorMessage?: string | null, fullPath: string, projectNumbers?: Array<number> | null, currentFolderPath: string, targetFolderPath?: string | null }> }> }> } };

export type GetClientFolderInfoQueryVariables = Types.Exact<{
  input: Types.SingleCustomerInput;
}>;


export type GetClientFolderInfoQuery = { __typename?: 'QueryModel', customers: { __typename?: 'CustomersQueryModel2', single?: { __typename?: 'Customer', number?: string | null, name: string, address1: string, address2: string } | null } };

export type GetProjectFolderInfoQueryVariables = Types.Exact<{
  input: Types.ProjectArgsInput;
}>;


export type GetProjectFolderInfoQuery = { __typename?: 'QueryModel', projects: { __typename?: 'ProjectsQueryModel', project?: { __typename?: 'Project', name: string, number: number, location: { __typename?: 'StateCounty', state: string, county: string }, projectManager: { __typename?: 'Employee', firstName: string, middleInitial: string, lastName: string }, billingAdmin: { __typename?: 'Employee', firstName: string, middleInitial: string, lastName: string } } | null } };

export type GetSharedDrivesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSharedDrivesQuery = { __typename?: 'QueryModel', projectFolders: { __typename?: 'ProjectFoldersQueryModel', drives: Array<{ __typename?: 'SharedDrive', driveLetter: string, physicalLocation: string }> } };


export const GetProjectFoldersDocument = gql`
    query GetProjectFolders($input: ProjectFoldersQueryInput!) {
  projectFolders {
    folders(input: $input) {
      path
      clientFolders {
        id
        path
        fullPath
        syncStatus
        syncErrorMessage
        customerNumber
        projectFolders {
          id
          name
          syncStatus
          syncErrorMessage
          fullPath
          currentFolderPath
          targetFolderPath
          projectId
        }
        groupedFolders {
          id
          name
          syncStatus
          syncErrorMessage
          fullPath
          projectNumbers
          currentFolderPath
          targetFolderPath
        }
      }
    }
  }
}
    `;

/**
 * __useGetProjectFoldersQuery__
 *
 * To run a query within a React component, call `useGetProjectFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectFoldersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProjectFoldersQuery(baseOptions: Apollo.QueryHookOptions<GetProjectFoldersQuery, GetProjectFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectFoldersQuery, GetProjectFoldersQueryVariables>(GetProjectFoldersDocument, options);
      }
export function useGetProjectFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectFoldersQuery, GetProjectFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectFoldersQuery, GetProjectFoldersQueryVariables>(GetProjectFoldersDocument, options);
        }
export type GetProjectFoldersQueryHookResult = ReturnType<typeof useGetProjectFoldersQuery>;
export type GetProjectFoldersLazyQueryHookResult = ReturnType<typeof useGetProjectFoldersLazyQuery>;
export type GetProjectFoldersQueryResult = Apollo.QueryResult<GetProjectFoldersQuery, GetProjectFoldersQueryVariables>;
export const GetClientFolderInfoDocument = gql`
    query GetClientFolderInfo($input: SingleCustomerInput!) {
  customers {
    single(input: $input) {
      number
      name
      address1
      address2
    }
  }
}
    `;

/**
 * __useGetClientFolderInfoQuery__
 *
 * To run a query within a React component, call `useGetClientFolderInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientFolderInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientFolderInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientFolderInfoQuery(baseOptions: Apollo.QueryHookOptions<GetClientFolderInfoQuery, GetClientFolderInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientFolderInfoQuery, GetClientFolderInfoQueryVariables>(GetClientFolderInfoDocument, options);
      }
export function useGetClientFolderInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientFolderInfoQuery, GetClientFolderInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientFolderInfoQuery, GetClientFolderInfoQueryVariables>(GetClientFolderInfoDocument, options);
        }
export type GetClientFolderInfoQueryHookResult = ReturnType<typeof useGetClientFolderInfoQuery>;
export type GetClientFolderInfoLazyQueryHookResult = ReturnType<typeof useGetClientFolderInfoLazyQuery>;
export type GetClientFolderInfoQueryResult = Apollo.QueryResult<GetClientFolderInfoQuery, GetClientFolderInfoQueryVariables>;
export const GetProjectFolderInfoDocument = gql`
    query GetProjectFolderInfo($input: ProjectArgsInput!) {
  projects {
    project(input: $input) {
      name
      number
      location {
        state
        county
      }
      projectManager {
        firstName
        middleInitial
        lastName
      }
      billingAdmin {
        firstName
        middleInitial
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetProjectFolderInfoQuery__
 *
 * To run a query within a React component, call `useGetProjectFolderInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectFolderInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectFolderInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProjectFolderInfoQuery(baseOptions: Apollo.QueryHookOptions<GetProjectFolderInfoQuery, GetProjectFolderInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectFolderInfoQuery, GetProjectFolderInfoQueryVariables>(GetProjectFolderInfoDocument, options);
      }
export function useGetProjectFolderInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectFolderInfoQuery, GetProjectFolderInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectFolderInfoQuery, GetProjectFolderInfoQueryVariables>(GetProjectFolderInfoDocument, options);
        }
export type GetProjectFolderInfoQueryHookResult = ReturnType<typeof useGetProjectFolderInfoQuery>;
export type GetProjectFolderInfoLazyQueryHookResult = ReturnType<typeof useGetProjectFolderInfoLazyQuery>;
export type GetProjectFolderInfoQueryResult = Apollo.QueryResult<GetProjectFolderInfoQuery, GetProjectFolderInfoQueryVariables>;
export const GetSharedDrivesDocument = gql`
    query getSharedDrives {
  projectFolders {
    drives {
      driveLetter
      physicalLocation
    }
  }
}
    `;

/**
 * __useGetSharedDrivesQuery__
 *
 * To run a query within a React component, call `useGetSharedDrivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedDrivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedDrivesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSharedDrivesQuery(baseOptions?: Apollo.QueryHookOptions<GetSharedDrivesQuery, GetSharedDrivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSharedDrivesQuery, GetSharedDrivesQueryVariables>(GetSharedDrivesDocument, options);
      }
export function useGetSharedDrivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSharedDrivesQuery, GetSharedDrivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSharedDrivesQuery, GetSharedDrivesQueryVariables>(GetSharedDrivesDocument, options);
        }
export type GetSharedDrivesQueryHookResult = ReturnType<typeof useGetSharedDrivesQuery>;
export type GetSharedDrivesLazyQueryHookResult = ReturnType<typeof useGetSharedDrivesLazyQuery>;
export type GetSharedDrivesQueryResult = Apollo.QueryResult<GetSharedDrivesQuery, GetSharedDrivesQueryVariables>;